import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
    errorGenerateOTP : ''
}

const generateOTPReducer =(state = initialState, {type, ...payload})=> {
    switch(type){
            case actionTypes.GENERATE_OTP_SUCCESS:
                return updateObject(state, {
                    errorGenerateOTP :'',
                    otpText: payload.response,
                    otpGeneratedTime: new Date()
                })
            case actionTypes.GENERATE_OTP_FAILED:
                return updateObject(state, {
                    errorGenerateOTP: payload.error.msg
                })
            default:{
                return state;
            }
        }
}

export default generateOTPReducer;